import './animations.css';
import './auth.css';
import './base.css';
import './breadcrumb.css';
import './button.css';
import './calendar.css';
import './colors.css';
import './component.css';
import './datatable.css';
import './dropdown.css';
import './dropzone.css';
import './error.css';
import './folders.css';
import './impagination.css';
import './input.css';
import './notification.css';
import './select2.css';
import './tab.css';
import './typography.css';